// Generated by ReScript, PLEASE EDIT WITH CARE

import * as IdFunctor$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/IdFunctor.bs.js";
var FieldId = IdFunctor$ApiTypes.Make({});
var FormId = IdFunctor$ApiTypes.Make({});
export { FieldId, FormId };
/* FieldId Not a pure module */